import { render, staticRenderFns } from "./SaleListAdmin.vue?vue&type=template&id=5eb9c30c&"
import script from "./SaleListAdmin.vue?vue&type=script&lang=js&"
export * from "./SaleListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports